// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
    appName: 'connectMyClub',
   googleMapsApiKey: 'AIzaSyDTzinomP2r7CYWAL8V2STW0BXnXi_RV_4',
  firebase: {
    apiKey: "AIzaSyAY30Q0y0pcRG3aKOpndjT1ftUeHHI692Q",
    authDomain: "push-notifications-219b1.firebaseapp.com",
    databaseURL: "https://push-notifications-219b1.firebaseio.com",
    projectId: "push-notifications-219b1",
    storageBucket: "push-notifications-219b1.appspot.com",
    messagingSenderId: "814471264227",
    appId: "1:814471264227:web:71cdb28c8f71af5af952d6",
    measurementId: "G-2Z138WMF2K",
    vapidKey: "BFhVz-xsXTDFosmzxSGVgkJSIB5LN29rb5h8rzwUdLy6Mlju26dROZnKNPOWngI8kof_WlS92WKHczyr4-3zd2w"
  },
  apiURL: 'https://app.connectmyclub.co.uk/app/',
  siteUrl: 'https://app.connectmyclub.co.uk/',

  stripeKey: 'pk_live_nYhopNPkh1hQro4JATqF4cDI', // Use 'pk_test_cz3EiQMj1FVFgyXryQcdVDzt' for development
  // Add your other environment variables here
  appColor: '#FF6000',
  statusBarText: 'light'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
